import React, { useState } from 'react';
import AxiosPublic from '../hooks/AxiosPublic';

const ContactPage = () => {
    // 1. FORM STATE
    const [formData, setFormData] = useState({
        name: '',
        company: '',
        email: '',
        budget: 'Basic Custom Web Application($1k)', // Matches the first real option
        details: ''
    });

    const [status, setStatus] = useState({ type: '', message: '' });
    const axiosPublic = AxiosPublic();

    // 2. INPUT HANDLER
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // 3. SUBMIT HANDLER
    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ type: 'loading', message: 'TRANSMITTING...' });

        try {
            const response = await axiosPublic.post('/contact', {
                name: formData.name,
                email: formData.email,
                platform: formData.company,
                budget: formData.budget,
                brief: formData.details
            });
            
            // FIXED: Axios uses .status, not .ok
            if (response.status === 200) {
                setStatus({ type: 'success', message: 'REQUEST TRANSMITTED' });
                setFormData({ name: '', company: '', email: '', budget: 'Basic Custom Web Application($1k)', details: '' });
                setTimeout(() => setStatus({ type: '', message: '' }), 5000);
            } else {
                setStatus({ type: 'error', message: 'TRANSMISSION FAILED' });
            }
        } catch (error) {
            console.error(error);
            setStatus({ type: 'error', message: 'SERVER OFFLINE' });
        }
    };

    return (
        <div className="min-h-screen bg-[#0f172a] text-white pt-24 pb-12 relative overflow-hidden">
            {/* Background Grid */}
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none"></div>

            <div className="container mx-auto px-6 relative z-10">
                {/* --- HEADER --- */}
                <div className="mb-16">
                    <span className="text-[#00F0FF] font-mono text-sm tracking-widest uppercase mb-4 block">
                        // Secure Channel
                    </span>
                    <h1 className="text-5xl md:text-7xl font-black font-display text-white">
                        INITIALIZE <br />
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00F0FF] to-white">COMMUNICATION</span>
                    </h1>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
                    {/* --- LEFT COLUMN: INFO & CARDS --- */}
                    <div>
                        <p className="text-gray-400 text-lg leading-relaxed mb-12 border-l-2 border-[#00F0FF] pl-6">
                            We don't do mass production. We hand-pick a limited number of projects to ensure your product is built to the highest standard.
                        </p>

                        {/* Direct Contact Cards */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
                            <div className="bg-[#27272a]/50 p-6 rounded-xl border border-white/5 hover:border-[#00F0FF]/30 transition-colors">
                                <h3 className="text-gray-500 text-xs font-mono uppercase tracking-widest mb-2">Email</h3>
                                <a href="mailto:info@toporion.net" className="text-xl font-bold text-white hover:text-[#00F0FF] transition-colors">
                                    info@toporion.net
                                </a>
                            </div>
                            <div className="bg-[#27272a]/50 p-6 rounded-xl border border-white/5 hover:border-[#00F0FF]/30 transition-colors">
                                <h3 className="text-gray-500 text-xs font-mono uppercase tracking-widest mb-2">HQ Location</h3>
                                <p className="text-xl font-bold text-white">
                                    Dhaka, Bangladesh
                                </p>
                            </div>

                            {/* NEW FULL-WIDTH CONTACT CARD */}
                            <div className="md:col-span-2 bg-[#27272a]/50 p-6 rounded-xl border border-[#00F0FF]/10 hover:border-[#00F0FF]/40 transition-all group">
                                <h3 className="text-gray-500 text-xs font-mono uppercase tracking-widest mb-6">// Rapid Response Hub</h3>

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                    {/* Phone */}
                                    <div className="flex items-center gap-3">
                                        <div className="p-2 bg-[#00F0FF]/10 rounded-lg text-[#00F0FF]">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="text-[10px] text-gray-300 uppercase font-mono tracking-tighter">Voice</p>
                                            <p className="text-sm font-bold">+880 1752-529-602</p>
                                        </div>
                                    </div>

                                    {/* WhatsApp */}
                                    <a href="https://wa.me/8801752529602" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
                                        <div className="p-2 bg-green-500/10 rounded-lg text-green-400">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                                                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.246 2.248 3.484 5.232 3.484 8.412-.003 6.557-5.338 11.892-11.893 11.892-1.997-.001-3.951-.5-5.688-1.448l-6.309 1.656zm6.224-3.52c1.54.914 3.51 1.403 5.46 1.404 5.452 0 9.889-4.437 9.892-9.891.001-2.646-1.027-5.132-2.896-7.003-1.868-1.87-4.35-2.898-6.996-2.899-5.454 0-9.891 4.438-9.894 9.892-.001 2.097.547 4.142 1.588 5.945l-1.07 3.91 4.01-1.053z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="text-[10px] text-gray-300 uppercase font-mono tracking-tighter">WhatsApp</p>
                                            <p className="text-sm font-bold text-green-400">Chat Now</p>
                                        </div>
                                    </a>

                                    {/* Team */}
                                    <div className="flex items-center gap-3">
                                        <div className="p-2 bg-purple-500/10 rounded-lg text-purple-400">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="text-[10px] text-gray-300 uppercase font-mono tracking-tighter">Team</p>
                                            <p className="text-sm font-bold">salman.rokon</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* FAQ Section */}
                        <div>
                            <h3 className="text-2xl font-bold text-white mb-6">Frequently Asked</h3>
                            <div className="space-y-4">
                                <details className="group bg-[#27272a]/30 border border-white/5 rounded-lg open:border-[#00F0FF]/30 transition-all">
                                    <summary className="flex justify-between items-center p-4 cursor-pointer font-bold text-gray-300 hover:text-white">
                                        What is your typical timeline?
                                        <span className="text-[#00F0FF] transition-transform group-open:rotate-180">↓</span>
                                    </summary>
                                    <div className="px-4 pb-4 text-gray-400 text-sm leading-relaxed">
                                        Most MVPs are delivered in 4-6 weeks. Complex enterprise platforms typically take 8-12 weeks depending on scope.
                                    </div>
                                </details>

                                <details className="group bg-[#27272a]/30 border border-white/5 rounded-lg open:border-[#00F0FF]/30 transition-all">
                                    <summary className="flex justify-between items-center p-4 cursor-pointer font-bold text-gray-300 hover:text-white">
                                        Do you work with existing codebases?
                                        <span className="text-[#00F0FF] transition-transform group-open:rotate-180">↓</span>
                                    </summary>
                                    <div className="px-4 pb-4 text-gray-400 text-sm leading-relaxed">
                                        Yes. We specialize in refactoring and modernizing legacy React/Node applications.
                                    </div>
                                </details>
                            </div>
                        </div>
                    </div>

                    {/* --- RIGHT COLUMN: THE FORM --- */}
                    <div className="bg-[#18181b] border border-white/10 p-8 md:p-10 rounded-3xl shadow-[0_0_50px_rgba(0,0,0,0.5)] relative overflow-hidden">
                        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#00F0FF] via-purple-500 to-[#00F0FF]"></div>

                        <form className="space-y-6 relative z-10" onSubmit={handleSubmit}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="group">
                                    <label className="block text-xs font-mono text-gray-500 mb-2 uppercase tracking-widest">// Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        required
                                        value={formData.name}
                                        onChange={handleChange}
                                        className="w-full bg-black/40 border border-white/10 rounded-lg p-4 text-white focus:outline-none focus:border-[#00F0FF] transition-colors"
                                        placeholder="John Doe"
                                    />
                                </div>
                                <div className="group">
                                    <label className="block text-xs font-mono text-gray-500 mb-2 uppercase tracking-widest">// Company</label>
                                    <input
                                        type="text"
                                        name="company"
                                        required
                                        value={formData.company}
                                        onChange={handleChange}
                                        className="w-full bg-black/40 border border-white/10 rounded-lg p-4 text-white focus:outline-none focus:border-[#00F0FF] transition-colors"
                                        placeholder="Acme Inc."
                                    />
                                </div>
                            </div>

                            <div className="group">
                                <label className="block text-xs font-mono text-gray-500 mb-2 uppercase tracking-widest">// Email Address</label>
                                <input
                                    type="email"
                                    name="email"
                                    required
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="w-full bg-black/40 border border-white/10 rounded-lg p-4 text-white focus:outline-none focus:border-[#00F0FF] transition-colors"
                                    placeholder="john@example.com"
                                />
                            </div>

                            <div className="group">
                                <label className="block text-xs font-mono text-gray-500 mb-2 uppercase tracking-widest">// Project Budget</label>
                                <select
                                    name="budget"
                                    value={formData.budget}
                                    onChange={handleChange}
                                    className="w-full bg-black/40 border border-white/10 rounded-lg p-4 text-white focus:outline-none focus:border-[#00F0FF] appearance-none"
                                >
                                    <option value="Please Select">Please Select</option>
                                    <option value="Basic Custom Web Application($1k)">Basic Custom Web Application($1k)</option>
                                    <option value="Custom SaaS Engines($3k)">Custom SaaS Engines($3k)</option>
                                    <option value="E-Commerce Ecosystems($2k)">E-Commerce Ecosystems($2k)</option>
                                    <option value="App Modernization">App Modernization</option>
                                </select>
                            </div>

                            <div className="group">
                                <label className="block text-xs font-mono text-gray-500 mb-2 uppercase tracking-widest">// Mission Details</label>
                                <textarea
                                    name="details"
                                    required
                                    value={formData.details}
                                    onChange={handleChange}
                                    rows="4"
                                    className="w-full bg-black/40 border border-white/10 rounded-lg p-4 text-white focus:outline-none focus:border-[#00F0FF] transition-colors"
                                    placeholder="Tell us what you want to build..."
                                ></textarea>
                            </div>

                            <button
                                type="submit"
                                disabled={status.type === 'loading'}
                                className="w-full py-4 bg-[#00F0FF] text-black font-bold uppercase tracking-widest rounded-lg hover:shadow-[0_0_20px_rgba(0,240,255,0.4)] transition-all disabled:bg-gray-600"
                            >
                                {status.message || 'Transmit Request'}
                            </button>

                            {status.type === 'success' && (
                                <p className="text-green-400 text-xs font-mono text-center animate-pulse">
                                    [SYSTEM]: MESSAGE SENT SUCCESSFULLY
                                </p>
                            )}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactPage;